import { WorkRequirementsListScreen } from "@/interactors/WorkRequirementsListScreen";

export default function WorkRequirementsList() {
  return <WorkRequirementsListScreen />;
}
